import { USER_PERMISSIONS } from 'dyl-components';

const PARENT_NAME = "dyl-admin";

export const DYL_ADMIN_SETTINGS = [
    {
        path: `broadcast-message/banner-display`,
        icon: 'fas fa-bullhorn',
        header: 'Broadcast Message',
        description: 'Set up system-wide announcements and display messages.',
        page: null,
        type: `${PARENT_NAME}.broadcast_messages`, favorite_type: "dyl-admin",
        userPermission: USER_PERMISSIONS.DATA_INTEGRATION_LOG_REPORT_VIEW
    },
];
